import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Hand = createReactComponent("Hand", ["svg", defaultAttributes, [["path", {
  d: "M18 11V6a2 2 0 00-2-2v0a2 2 0 00-2 2v0",
  key: "1dh6yr"
}], ["path", {
  d: "M14 10V4a2 2 0 00-2-2v0a2 2 0 00-2 2v2",
  key: "1n6pg8"
}], ["path", {
  d: "M10 10.5V6a2 2 0 00-2-2v0a2 2 0 00-2 2v8",
  key: "1c3tix"
}], ["path", {
  d: "M18 8a2 2 0 114 0v6a8 8 0 01-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 012.83-2.82L7 15",
  key: "az17h4"
}]]]);
export default Hand;